import React from 'react';
import PropTypes from 'prop-types';
import { NavWrapper } from 'components/Header/NavWrapper';
import { UnsubscribedUserNav } from './Navs/UnsubscribedUserNav';
import { ActiveUserNav } from './Navs/ActiveUserNav';
import { LoggedInUserLinksContainer } from './NavItems/LoggedInUserLinksContainer';
import { LiveProductLinks } from './NavItems/LiveProductLinks';
import { GoProductLinks } from './NavItems/GoProductLinks';

export const Navigation = ({
  canViewUnifiedSearch,
  isMobile,
  isLoggedIn,
  isUnpaidUser,
  isUnsubscribedUser,
  isActiveUser,
  onClick,
  isLivePage,
  isGoPage,
  user,
  ...otherProps
}) => {
  const shouldShowUnsubscribedNav = !isLoggedIn || isUnsubscribedUser;
  const shouldShowActiveNav = isActiveUser || isUnpaidUser;
  const loggedInOnMobile = isLoggedIn && isMobile;

  const shouldShowNav = !!(shouldShowUnsubscribedNav || shouldShowActiveNav || loggedInOnMobile);

  return (
    shouldShowNav && (
      <NavWrapper isMobile={isMobile}>
        {/*  eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
        <ul onClick={onClick}>
          {isLivePage && <LiveProductLinks />}
          {isGoPage && <GoProductLinks />}
          {shouldShowUnsubscribedNav && (
            <UnsubscribedUserNav {...otherProps} isLoggedIn={isLoggedIn} isLivePage={isLivePage} isGoPage={isGoPage} />
          )}
          {shouldShowActiveNav && <ActiveUserNav user={user} isLivePage={isLivePage} isGoPage={isGoPage} />}
          {isLoggedIn && isMobile && <LoggedInUserLinksContainer canViewUnifiedSearch={canViewUnifiedSearch} />}
        </ul>
      </NavWrapper>
    )
  );
};

Navigation.propTypes = {
  canViewUnifiedSearch: PropTypes.bool,
  onClick: PropTypes.func,
  isMobile: PropTypes.bool,
  isActiveUser: PropTypes.bool,
  isUnpaidUser: PropTypes.bool,
  isUnsubscribedUser: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isLivePage: PropTypes.bool,
  isGoPage: PropTypes.bool,
};
